<template>
  <v-parallax :src="require('@/assets/wallpaper/7.jpg')" :height="350">
    <v-layout align-center justify-center row fill-height class="white-links">
      <div style="text-align:right;">
        <a href="https://www.christuszentrum-bs.de/" target="_blank">Link</a><br>
        <a href="https://royal-rangers.de/" target="_blank">Link</a><br>
        <a href="https://royal-rangers.shop/" target="_blank">Impressum &auml; Zeug</a>
      </div>
      <div>
        <div class="vr"></div>
      </div>
      <div>
        <a href="https://www.christuszentrum-bs.de/" target="_blank">ChristusZentrum Braunschweig</a><br>
        <a href="https://royal-rangers.de/" target="_blank">Royal Rangers Deutschland</a><br>
        <a href="https://royal-rangers.shop/" target="_blank">Royal Rangers Shop</a>
      </div>
    </v-layout>
  </v-parallax>
</template>

<script>
  export default {
    data() {
      return {
      
      }
    }
  }
</script>

<style>
.v-footer .v-parallax__content{
  padding:0px;
  background-color:rgba(0,0,0,0.3);
  width:100vw;
  font-size: 110%;
}
.vr{
  height: 200px;
  width: 0px;
  border-left: 3px dotted white;
  margin: 30px;
}
.white-links a{
  color: white;
  text-decoration: underline;
}
</style>
